import * as turf from '@turf/turf';

// Buffer a point (lon/lat) by radius in kilometers → GeoJSON Feature<Polygon>.
export function circleArea(lon, lat, km) {
  return turf.circle([lon, lat], km, { steps: 96, units: 'kilometers' });
}

// Union a list of polygon features. Returns a single feature or null.
// Note: Turf v7 changed union() to take a FeatureCollection.
export function unionAll(features) {
  const polys = features.filter((f) => f && f.geometry);
  if (!polys.length) return null;
  if (polys.length === 1) return polys[0];
  try {
    const fc = turf.featureCollection(polys);
    return turf.union(fc) || polys[0];
  } catch (e) {
    console.warn('union failed', e);
    return polys[0];
  }
}

// Subtract `minus` from `base`. Turf v7 difference() takes a FeatureCollection
// of exactly [base, minus].
export function difference(base, minus) {
  if (!base) return null;
  if (!minus) return base;
  try {
    const fc = turf.featureCollection([base, minus]);
    const out = turf.difference(fc);
    return out || null;
  } catch (e) {
    console.warn('difference failed', e);
    return base;
  }
}

// Given target polygon + postcode features, return matching features.
// mode = 'centroid' or 'intersects'
export function filterPostcodes(target, postcodes, mode) {
  if (!target) return [];
  const out = [];
  for (const pc of postcodes) {
    let hit = false;
    try {
      if (mode === 'centroid') {
        const c = turf.centroid(pc);
        hit = turf.booleanPointInPolygon(c, target);
      } else {
        hit = turf.booleanIntersects(pc, target);
      }
    } catch {
      // skip invalid geoms
    }
    if (hit) out.push(pc);
  }
  return out;
}

export function bbox(feature) {
  try { return turf.bbox(feature); } catch { return null; }
}
